import { PRESETS_INSPECTION_RESULT } from 'app/modules/inspection/constants';
import { InspectionPOItem } from 'app/modules/inspection/types';
import { QMASLazyDocument, Status } from 'app/modules/ui';

export const DESCRIPTION_DEF = [
  {
    label: 'Quantity Available Progress',
    dataIndex: 'progress',
    span: 3,
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: 'Book Qty',
    dataIndex: 'bookQuantity',
    span: 3,
    render: (
      value: string,
      record,
      meta: {
        poItem: InspectionPOItem;
      }
    ) => {
      const { poItem } = meta;
      if (poItem) {
        return poItem.orderQty || '';
      }
      return '';
    }
  },
  {
    label: 'Request Produced %',
    dataIndex: 'requestProduced',
    span: 3,
    render: (value: string) => {
      if (value) return `${value}%`;
      return value || 'N/A';
    }
  },
  {
    label: 'Produced Qty',
    dataIndex: 'producedQuantity',
    render: (
      value: string,
      record,
      meta: {
        poItem: InspectionPOItem;
      }
    ) => {
      const { poItem } = meta;
      return `${value || 0}/${poItem?.orderQty ?? 0}`;
    }
  },
  {
    label: 'Product %',
    dataIndex: 'producedPercentage',
    span: 2,
    render: (value: string, record) => {
      const { requestProduced, producedPercentage } = record;
      const numberRequestProduced = isNaN(parseInt(requestProduced))
        ? 0
        : parseInt(requestProduced);
      const numberProducedQuantity = isNaN(parseInt(producedPercentage || 0))
        ? 0
        : parseInt(producedPercentage);
      const status =
        numberProducedQuantity >= numberRequestProduced ? 'passed' : 'failed';
      const [, color] = PRESETS_INSPECTION_RESULT.get(status) || [
        '',
        'default'
      ];
      return (
        <Status type="text" value={`${value || 0}%`} color={color as string} />
      );
    }
  },
  {
    label: 'Request Packed %',
    dataIndex: 'requestPacked',
    span: 3,
    render: (value: string) => {
      return `${value || 0}%`;
    }
  },
  {
    label: 'Packed Qty',
    dataIndex: 'packedQuantity',
    render: (
      value: string,
      record,
      meta: {
        poItem: InspectionPOItem;
      }
    ) => {
      const { poItem } = meta;

      return `${value || 0}/${poItem?.orderQty ?? 0}`;
    }
  },
  {
    label: 'Packed %',
    dataIndex: 'packedPercentage',
    span: 3,
    render: (value: string, record) => {
      const { requestPacked, packedPercentage } = record;
      const numberRequestProduced = isNaN(parseInt(requestPacked))
        ? 0
        : parseInt(requestPacked);

      const numberPackedQuantity = isNaN(parseInt(packedPercentage || 0))
        ? 0
        : parseInt(packedPercentage);

      const status =
        numberPackedQuantity > numberRequestProduced ? 'passed' : 'failed';
      const [, color] = PRESETS_INSPECTION_RESULT.get(status) || [
        '',
        'default'
      ];
      return (
        <Status type="text" value={`${value || 0}%`} color={color as string} />
      );
    }
  },
  {
    label: 'Reference Media',
    dataIndex: 'referenceMedia',
    className: 'reference-media',
    render: (value: any) => {
      if (Array.isArray(value)) {
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            {value.map((item) => {
              return (
                <QMASLazyDocument
                  key={item}
                  alt="attachments"
                  documentId={item}
                />
              );
            })}
          </div>
        );
      }
      return null;
    }
  }
];
